export default __webpack_public_path__ + "static/media/officeaddress@2x.e19220fd.png";